import { render, staticRenderFns } from "./Person.vue?vue&type=template&id=de616a98&"
import script from "./Person.vue?vue&type=script&lang=js&"
export * from "./Person.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports